'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_jdk_CollectionConverters$() {
}
export { $c_s_jdk_CollectionConverters$ as $c_s_jdk_CollectionConverters$ };
$p = $c_s_jdk_CollectionConverters$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_jdk_CollectionConverters$;
/** @constructor */
function $h_s_jdk_CollectionConverters$() {
}
export { $h_s_jdk_CollectionConverters$ as $h_s_jdk_CollectionConverters$ };
$h_s_jdk_CollectionConverters$.prototype = $p;
var $d_s_jdk_CollectionConverters$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_jdk_CollectionConverters$, "scala.jdk.CollectionConverters$", ({
  uJ: 1,
  sK: 1,
  sN: 1
}));
export { $d_s_jdk_CollectionConverters$ as $d_s_jdk_CollectionConverters$ };
var $n_s_jdk_CollectionConverters$;
function $m_s_jdk_CollectionConverters$() {
  if ((!$n_s_jdk_CollectionConverters$)) {
    $n_s_jdk_CollectionConverters$ = new $c_s_jdk_CollectionConverters$();
  }
  return $n_s_jdk_CollectionConverters$;
}
export { $m_s_jdk_CollectionConverters$ as $m_s_jdk_CollectionConverters$ };
